import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MessagesSquare, Waypoints } from "lucide-react";
import { customerClient } from "../lib/api";

export default function CustomerConversations() {
  const [convs, setConvs] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    customerClient()
      .get("/public/conversations")
      .then(({ data }) => setConvs(data))
      .catch(() => navigate("/customer/login"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="customer-conversations-page">
      <header className="bg-white border-b border-[#E5E5E5]">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Waypoints className="h-5 w-5" />
            <span className="font-heading font-bold">Customer portal</span>
          </div>
          <Link to="/customer/login" className="text-sm font-medium text-neutral-900 underline underline-offset-4 hover:text-neutral-500 transition-colors duration-150" data-testid="customer-new-link">
            New login link
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10">
        {!convs ? (
          <p className="text-neutral-400">Loading…</p>
        ) : convs.length === 0 ? (
          <div className="text-center py-24" data-testid="conversations-empty">
            <MessagesSquare className="h-12 w-12 text-neutral-300 mx-auto" />
            <p className="mt-4 text-neutral-500">No conversations yet for this email.</p>
          </div>
        ) : (
          <div className="space-y-8">
            {Object.entries(
              convs.reduce((acc, c) => {
                const k = c.business_name || "Other";
                (acc[k] = acc[k] || []).push(c);
                return acc;
              }, {})
            ).map(([biz, items]) => (
              <div key={biz}>
                <div className="flex items-center gap-3 mb-3" data-testid={`portal-business-${biz}`}>
                  <h2 className="font-heading font-bold text-lg">{biz}</h2>
                  <span className="text-xs text-neutral-500">{items.length} conversation(s)</span>
                </div>
                <div className="space-y-3">
                  {items.map((c) => (
              <Link
                key={c.id}
                to={`/customer/conversations/${c.id}`}
                data-testid={`conversation-item-${c.id}`}
                className="block bg-white border border-[#E5E5E5] rounded-2xl p-5 hover:shadow-sm transition-shadow duration-200"
              >
                <div className="flex items-center justify-between gap-4">
                  <div className="min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="font-bold truncate">{c.form_title}</span>
                      {c.unread > 0 && (
                        <span className="text-[10px] bg-neutral-900 text-white rounded-full px-2 py-0.5" data-testid={`conversation-unread-${c.id}`}>
                          {c.unread} new
                        </span>
                      )}
                    </div>
                    <div className="text-xs text-neutral-400 mt-0.5">Opened {new Date(c.created_at).toLocaleDateString()}</div>
                    {c.last_message && (
                      <p className="text-sm text-neutral-500 mt-2 truncate">{c.last_message.body || "Attachment"}</p>
                    )}
                  </div>
                  <span className="text-xs text-neutral-400 shrink-0">{new Date(c.updated_at).toLocaleDateString()}</span>
                </div>
              </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
